module.exports = __webpack_public_path__ + "img/terror-blade.a2d2c02e.png";